import request from '../utils/request';

/**
 * Admin-side wrapper for /api/v1/admin/guest-notifications.
 */
export const GuestPushNotificationService = {
  searchGuests: async (query, limit = 25) => {
    const response = await request.post('/admin/guest-notifications/search', { query, limit });
    return response.data?.guests || [];
  },

  preview: async (target) => {
    const response = await request.post('/admin/guest-notifications/preview', { target });
    return response.data;
  },

  send: async (payload) => {
    const response = await request.post('/admin/guest-notifications/send', payload);
    return response.data?.notification;
  },

  listHistory: async (limit = 50) => {
    const response = await request.get('/admin/guest-notifications', { params: { limit } });
    return response.data?.items || [];
  },
};

export default GuestPushNotificationService;
